"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = void 0;

var _browser = require("./browser");

var isBrowser = typeof window !== 'undefined';
var browserLogger = isBrowser ? new _browser.BrowserLogger() : null;
var logger = {
  error: function error(_error, context) {
    if (browserLogger) {
      browserLogger.error(_error, context);
      return;
    } // Server-side: callers should use req.insidedContext.logger directly.
    // This fallback exists only for isomorphic code that doesn't have context access.


    console.error('[logger] Use req.insidedContext.logger on the server.', _error);
  }
};
exports.logger = logger;